
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/clc",
      function () {
        return require("private-next-pages/about/clc.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/clc"])
      });
    }
  